"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var client_1 = require("@apollo/client");
var index_1 = __importDefault(require("../../index"));
var Map_1 = __importDefault(require("../../../Map"));
var RoutesDrawerContent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    var query = _a.query, queryVariablesFormatter = _a.queryVariablesFormatter, queryVariables = _a.queryVariables, queryGeoJson = _a.queryGeoJson, mapBoxProps = _a.mapBoxProps;
    var _0 = client_1.useQuery(query, {
        variables: queryVariablesFormatter
            ? queryVariablesFormatter(queryVariables)
            : queryVariables,
    }), loading = _0.loading, data = _0.data;
    var _1 = client_1.useQuery(queryGeoJson, {
        variables: {
            routeId: queryVariables.id,
        },
    }), loadingGeoJson = _1.loading, dataGeoJson = _1.data;
    if (loading || !data || loadingGeoJson || !dataGeoJson) {
        return (react_1.default.createElement("div", { style: { top: "50%", left: "50%", position: "absolute" } },
            react_1.default.createElement(antd_1.Space, { size: "middle" },
                react_1.default.createElement(antd_1.Spin, { size: "large", tip: "Loading..." }))));
    }
    var routes = ((_c = (_b = dataGeoJson === null || dataGeoJson === void 0 ? void 0 : dataGeoJson.routeGeojson) === null || _b === void 0 ? void 0 : _b.features) === null || _c === void 0 ? void 0 : _c.map(function (route, index) {
        var _a, _b;
        return {
            id: index,
            locations: ((_b = (_a = route.geometry) === null || _a === void 0 ? void 0 : _a.coordinates) === null || _b === void 0 ? void 0 : _b.map(function (arr) {
                return {
                    longitude: arr[1],
                    latitude: arr[0],
                };
            })) || [],
        };
    })) || [];
    var containers = ((_e = (_d = data === null || data === void 0 ? void 0 : data.route) === null || _d === void 0 ? void 0 : _d.stops) === null || _e === void 0 ? void 0 : _e.edges.filter(function (edge) { return edge.node.container && edge.node.container; }).map(function (edge) { return ({
        id: edge.node.container.id,
        location: {
            longitude: edge.node.container.location.longitude,
            latitude: edge.node.container.location.latitude,
        },
    }); })) || [];
    var depots = ((_g = (_f = data === null || data === void 0 ? void 0 : data.route) === null || _f === void 0 ? void 0 : _f.stops) === null || _g === void 0 ? void 0 : _g.edges.filter(function (edge) { return edge.node.depot && edge.node.depot.id; }).map(function (edge) { return ({
        id: edge.node.depot.id,
        type: edge.node.depot.depotType === "depot" ? "depot" : "wasteStation",
        location: {
            longitude: edge.node.depot.location.longitude,
            latitude: edge.node.depot.location.latitude,
        },
    }); })) || [];
    return (react_1.default.createElement(antd_1.Row, null,
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement(Map_1.default, { mapBoxProps: mapBoxProps, containers: containers, inquiries: [], routes: routes, vehicles: [], depots: depots })),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Route ID"),
            react_1.default.createElement("br", null),
            " ",
            ((_h = data.route) === null || _h === void 0 ? void 0 : _h.id) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Driver e-mail"),
            react_1.default.createElement("br", null),
            " ",
            ((_l = (_k = (_j = data.route) === null || _j === void 0 ? void 0 : _j.driver) === null || _k === void 0 ? void 0 : _k.user) === null || _l === void 0 ? void 0 : _l.email) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Driver name"),
            react_1.default.createElement("br", null),
            ((_p = (_o = (_m = data.route) === null || _m === void 0 ? void 0 : _m.driver) === null || _o === void 0 ? void 0 : _o.user) === null || _p === void 0 ? void 0 : _p.firstName) + " " + ((_s = (_r = (_q = data.route) === null || _q === void 0 ? void 0 : _q.driver) === null || _r === void 0 ? void 0 : _r.user) === null || _s === void 0 ? void 0 : _s.lastName) ||
                ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Project ID"),
            react_1.default.createElement("br", null),
            " ",
            ((_u = (_t = data.route) === null || _t === void 0 ? void 0 : _t.project) === null || _u === void 0 ? void 0 : _u.id) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Vehicle ID"),
            react_1.default.createElement("br", null),
            " ",
            ((_w = (_v = data.route) === null || _v === void 0 ? void 0 : _v.vehicle) === null || _w === void 0 ? void 0 : _w.id) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Vehicle name"),
            react_1.default.createElement("br", null),
            " ",
            ((_y = (_x = data.route) === null || _x === void 0 ? void 0 : _x.vehicle) === null || _y === void 0 ? void 0 : _y.name) || ""),
        react_1.default.createElement(antd_1.Col, { span: 12 },
            react_1.default.createElement("strong", null, "Route stop count"),
            react_1.default.createElement("br", null),
            " ",
            ((_z = data.route) === null || _z === void 0 ? void 0 : _z.stopsCount) || "")));
};
var RoutesDrawer = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, restProps = __rest(_a, ["visible", "onClose"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(index_1.default, { visible: visible, onClose: onClose, title: "Routes" },
            react_1.default.createElement(RoutesDrawerContent, __assign({}, restProps)))));
};
exports.default = RoutesDrawer;
